import { Component, OnInit, Input, Inject } from '@angular/core';

import { SharedDetailNewsService } from './shared-detail-news.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { SetupService } from '@core/services/setup';
import { WINDOW } from '@core/http/window.providers';

@Component({
    selector: 'app-shared-detail-news',
    templateUrl: './shared-detail-news.component.html',
    styleUrls: ['./shared-detail-news.component.scss'],
})
export class SharedDetailNewsComponent implements OnInit {
    /**
     * Parâmetro recebido para detalhar notícia
     */
    @Input() postId: any;

    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    // registers: any;
    news: any;

    constructor(
        private sharedDetailService: SharedDetailNewsService,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private title: Title,
        private setupService: SetupService,
        @Inject(WINDOW) public window: Window
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe((param) => {
            this.postId = param.postId;
            this.detail();
        });
    }

    /**
     * detail() - Buscar detalhes da notícia publicada
     */
    detail() {
        this.sharedDetailService.getDetailNews(this.postId).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        const [news] = response.registers;
        this.news = news;
        this.news.text = news.text ? this.sanitizer.bypassSecurityTrustHtml(news.text) : news.text;
        this.news.texto_footer = news.texto_footer
            ? this.sanitizer.bypassSecurityTrustHtml(news.texto_footer)
            : news.texto_footer;
        this.title.setTitle(this.news.title);
        //console.log(this.news);
        // //console.log('SharedDetailNewsComponent successCallbackApi');
        // //console.log(this.registers);
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.news = null;
    }

    onPageChange(pageNumber) {
        //console.log(pageNumber);
    }
}
